/** Shared defaults for the free-gift pop-up widget */

export interface PopupDesign {
  title: string;
  description: string;
  ctaLabel: string;
  secondaryLabel: string;
  accentColor: string;
  backgroundColor: string;
  textColor: string;
  mutedColor: string;
  overlayColor: string;
  borderRadius: number;
  maxWidth: number;
  showClose: boolean;
  giftCardBg: string;
  giftCardBorder: string;
  selectedBorder: string;
  buttonTextColor: string;
  fontFamily: string;
  /** When true, storefront uses the live theme scheme (Product information first) */
  autoFitTheme: boolean;
  /** Scheme id from last Refresh (e.g. scheme-2) — pinned for storefront Auto-fit */
  themeSchemeId: string | null;
}

export const DEFAULT_POPUP_DESIGN: PopupDesign = {
  title: "You've unlocked a special gift!",
  description:
    'Your cart qualifies for free gifts. Choose your reward before checkout.',
  ctaLabel: 'Add free gift',
  secondaryLabel: 'Maybe later',
  accentColor: '#0D7A5F',
  backgroundColor: '#FFFFFF',
  textColor: '#1A1A1A',
  mutedColor: '#6D7175',
  overlayColor: 'rgba(15, 23, 28, 0.55)',
  borderRadius: 16,
  maxWidth: 440,
  showClose: true,
  giftCardBg: '#F7F8F7',
  giftCardBorder: '#E3E5E4',
  selectedBorder: '#0D7A5F',
  buttonTextColor: '#FFFFFF',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  autoFitTheme: true,
  themeSchemeId: null,
};

export const DEMO_GIFTS = [
  { id: 'g1', title: 'Care kit sample', meta: 'Free gift' },
  { id: 'g2', title: 'Travel pouch', meta: 'Free gift' },
  { id: 'g3', title: 'Mini candle', meta: 'Free gift' },
];

/** Normalize any CSS color string to #rrggbb for <input type="color"> */
export function toColorInputValue(css: string, fallback = '#000000'): string {
  const s = String(css || '').trim();
  if (/^#[0-9a-fA-F]{6}$/.test(s)) return s;
  if (/^#[0-9a-fA-F]{3}$/.test(s)) {
    const r = s[1];
    const g = s[2];
    const b = s[3];
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  const m = s.match(
    /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i,
  );
  if (m) {
    const hex = (n: number) => n.toString(16).padStart(2, '0');
    return `#${hex(+m[1])}${hex(+m[2])}${hex(+m[3])}`;
  }
  return fallback;
}
